import { memo, forwardRef } from 'react';

import { CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import * as Styles from './styles';
import { Flex } from 'styles/Flex';

interface CheckboxProps extends MuiCheckboxProps {
  label?: string;
  leftLabel?: boolean;
  helperText?: string;
  clearHelperTextSpacing?: boolean;
}

const BaseCheckbox = forwardRef<any, CheckboxProps>(
  ({ label, leftLabel, clearHelperTextSpacing, helperText, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <Flex column gap={1}>
        <Styles.Container>
          {leftLabel && label && <label>{t(label)}</label>}
          <Styles.Checkbox {...props} inputRef={ref} />
          {!leftLabel && label && <label>{t(label)}</label>}
        </Styles.Container>
        {!clearHelperTextSpacing && <Styles.HelperText>{helperText}</Styles.HelperText>}
      </Flex>
    );
  },
);

export const Checkbox = memo(BaseCheckbox);
